import React from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
import styles from './DeviceWithoutTravel.module.scss';
import lastLocationImg from '../../../../assets/svg/my_location.svg'

interface InfoCardProps {
    message: string;
    lastLocation: string;
}

const DeviceWithoutTravel: React.FC<InfoCardProps> = ({ message, lastLocation }) => {
    return (
        <Card className={styles.CardWithoutTravel}>
            <CardHeader
                className={styles.CardWithoutTravelHeader}
                title={message}
            />
            <hr/>
            <CardContent className={styles.CardWithoutTravelContent}>
                <img src={lastLocationImg} alt="lastLocation"/>
                <Typography>
                    {lastLocation}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default DeviceWithoutTravel;